import { useContext } from "react";
import DataTableColumnVisibilityContext from "../components/DataTableColumnVisibilityContext";

const useTableColumnVisibility = () => {
  const context = useContext(DataTableColumnVisibilityContext);
  if (!context) {
    throw new Error(
      "useTableColumnVisibility must be used within a DataTableColumnVisibilityContext",
    );
  }
  return context;
};

export default useTableColumnVisibility;
